import React, { useEffect, useMemo } from "react";
import { useLocation } from "react-router";
import { IonContent, IonMenu } from "@ionic/react";
import MainMenu from "./MainMenu";
import AdminMenu from "../Admin/AdminMenu";

const Menu = () => {
  const location = useLocation();

  const isAdmin = useMemo(() => {
    return location.pathname.indexOf("admin") >= 0;
  }, [location]);

  useEffect(() => {}, []);

  return (
    <IonMenu type="overlay" contentId="main" disabled={false}>
      <IonContent forceOverscroll={false}>
        {isAdmin ? <AdminMenu /> : <MainMenu />}
      </IonContent>
    </IonMenu>
  );
};

export default Menu;
